import { GLOSSARY_ENTRIES } from "@/lib/glossary";
import i18n from "@/i18n";

/** `?q=` maakt zoekresultaten deelbaar en vult de zoekbalk vooraf in. */
// q is optioneel: een altijd-aanwezige lege q liet de router elke bezoeker
// doorsturen naar ?q= (307), waardoor ook de vooraf gemaakte pagina niet werkte.
export function validateGlossarySearch(search: Record<string, unknown>): { q?: string } {
  return typeof search.q === "string" && search.q ? { q: search.q } : {};
}

/** schema.org DefinedTermSet zodat zoekmachines en AI-assistenten de definities begrijpen. */
export function glossaryJsonLd(lang: "nl" | "fr" | "en") {
  const t = i18n.getFixedT(lang, "home");
  const tc = i18n.getFixedT(lang, "common");
  return {
    "@context": "https://schema.org",
    "@type": "DefinedTermSet",
    name: tc("glossary_page.title") as unknown as string,
    description: tc("glossary_page.sub") as unknown as string,
    hasDefinedTerm: GLOSSARY_ENTRIES.map((e) => ({
      "@type": "DefinedTerm",
      name: t(e.titleKey) as unknown as string,
      description: t(e.introKey) as unknown as string,
    })),
  };
}
